import { likeButtonText, restartButtonText } from "./literals"

export const MIN_DOTS_DISPLAY_TIME = 1500
export const CONSULTANT_TYPE = process.env.REACT_APP_CONSULTANT_ID
export const POST_WITH_SELECTED_WINES_URL = process.env.REACT_APP_POST_WITH_SELECTED_WINES_URL
export const INITIAL_CHAT_MESSAGES = [
  'Oi, eu sou a Pipa, a assistente digital de vinhos do **[Wine Locals](https://www.wine-locals.com)**. 🍷😍',
  'Estou aqui para ajudar você a encontrar um vinho perfeito para o seu momento e perfil.',
  'Me conta um pouco mais o que você tá buscando.'
]
export const INITIAL_RESULT_OPTIONS = [
  { name: likeButtonText },
  { name: restartButtonText },
]
